<template>
  <ul v-if="links?.length" class="nav-account-links">
    <li v-for="(item, index) in links" :key="index" :class="{ 'nav-group-separator': item.isSignOut }">
      <Link :href="item.url" :tracking="item.tracking" @click="onClick(item)">
        {{ item.text }}
      </Link>
    </li>
  </ul>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed } from 'vue';
import { GET_MYACCOUNT_LINKS } from '#shared/types/getters';
import Link from '../common/Link';
import useSignOutClick from '~/composables/useSignOutClick';

const envProps = useEnvProps();
const isMcom = envProps.isMcom;
const navHeader = useNavHeader();

const links = computed(() => navHeader[GET_MYACCOUNT_LINKS]);

function onClick(item) {
  if (item.isSignOut) {
    useSignOutClick(isMcom);
  }
}
</script>

<style lang="scss">
@import '~/assets/scss/mixins';

.nav-account-links {
  @include padding-top-s;
  list-style: none;

  li + li {
    margin-top: 20px;
  }

  li + .nav-group-separator {
    @include margin-top-s;
  }

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.nav-group-separator {
  @include padding-top-s;
  border-top: 1px solid $gray-3-color;
}
</style>

<style lang="scss" brand="bcom">
.nav-account-links li:last-child a {
  text-transform: capitalize;
}
</style>
